module.exports = __webpack_public_path__ + "static/media/learning.e38d4656.svg";